export default __webpack_public_path__ + "static/media/10.218813e1.svg";